const stdInfoRoutes = [
  {
    path: "/std-info",
    name: "",
    meta: {
      title: "비교과",
      isDynamic: true,
    },
    children: [
      {
        path: "index",
        name: "stdInfoIndex",
        meta: {
          title: "학생 상세 정보 조회",
          titleEn: "Student Information Inquiry",
          menuCd: "STAFF_STUDENT_INFO",
          isDynamic: true,
        },
        component: () => import("@/views/staff/stdInfo/StaffStdInfoIndex.vue"),
      },
      {
        path: "ability-status", // std-info/ability-status
        meta: {
          title: "핵심역량 취득 현황",
          isDynamic: true,
          menuCd: "ABILITY_STATUS",
        },
        component: () => import("@/views/staff/stdInfo/StaffAbilityStatusIndex.vue"),
      },
    ],
  },
];

export default stdInfoRoutes;
